import { UserState } from './modules/User/State';

export interface RootState {
    user?: UserState;
}

export const state: RootState = {};
